import { config } from './config';

export const analytics = {
  measurementId: config.analytics.measurementId
};
